import React from "react";
import Logo from "../../authentication/components/Logo";

interface SidebarLogoProps {
  mobileView?: boolean;
}

export const SidebarLogo: React.FC<SidebarLogoProps> = ({ mobileView }) => {
  if (!mobileView) {
    return null;
  }

  return <Logo isLoginPageLogo={false} />;
};

